import { useState, ChangeEvent } from 'react';

// material-ui
import { Badge, Grid, InputLabel, List, ListItemButton, ListItemIcon, ListItemText, Switch } from '@mui/material';

// assets
//@ts-ignore
import { Bag2, Card, Edit2, Like1, Logout, Profile, Profile2User, Setting2, Lock1 } from 'iconsax-react';
import LogoutIcon from '@mui/icons-material/Logout';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';

import OrderRequestDrawer from '../OrderRequestDrawer';
import OrderRequestDrawerRecommendation from '../OrderRequestDrawerRecommendation';

import { useDataContext } from 'contexts/DataContext';
import SettingsMenu from '../SettingsMenu';
import { useFirebaseContext } from 'contexts/FirebaseContext';
// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

interface Props {
  setOpenLogoutModal: (val: boolean) => void;
  setOpenDisconnectModal: (val: boolean) => void;
  setOpenChangePasswordModal: (val: boolean) => void;
  setOrderRequestCount: (val: number) => void;
  orderRequestCount: number;
  setRecommendationRequestCount: (val: number) => void;
  recommendationRequestCount: number;
}

const ProfileTab = ({
  setOpenLogoutModal,
  setOpenDisconnectModal,
  setOpenChangePasswordModal,
  setOrderRequestCount,
  orderRequestCount,
  setRecommendationRequestCount,
  recommendationRequestCount
}: Props) => {
  const [isOrderRequestDrawerOpen, setIsOrderRequestDrawerOpen] = useState<boolean>(false);
  const [isOrderRequestDrawerRecommendationOpen, setIsOrderRequestDrawerRecommendationOpen] = useState<boolean>(false);
  const [settingsMenuOpen, setSettingsMenuOpen] = useState<boolean>(false);

  const { user } = useFirebaseContext();
  const permissions = user?.permissions;
  const hasViewOrderPermission = permissions?.includes('canViewOrderRequest');

  const { isAdvanced, setAdvanced } = useDataContext();

  const handleToggleAdvanced = (e: ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setAdvanced(!checked);
  };

  const handleToggleSettings = () => {
    setSettingsMenuOpen((prev) => !prev);
  };

  return (
    <>
      {isOrderRequestDrawerOpen && (
        <OrderRequestDrawer
          open={isOrderRequestDrawerOpen}
          setOpen={setIsOrderRequestDrawerOpen}
          setOrderRequestCount={setOrderRequestCount}
        />
      )}

      {isOrderRequestDrawerRecommendationOpen && (
        <OrderRequestDrawerRecommendation
          open={isOrderRequestDrawerRecommendationOpen}
          setOpen={setIsOrderRequestDrawerRecommendationOpen}
          setRecommendationRequestCount={setRecommendationRequestCount}
        />
      )}

      {settingsMenuOpen && <SettingsMenu open={settingsMenuOpen} handleToggle={handleToggleSettings} />}

      <Grid container direction="row" alignItems="center" spacing={1} sx={{ px: 2, mt: 0.5 }}>
        <Grid item>
          <InputLabel htmlFor="end-date" sx={{ fontWeight: 'bold', fontSize: '14px' }}>
            Advanced:
          </InputLabel>
        </Grid>
        <Grid item>
          <Switch color="primary" checked={isAdvanced} onChange={handleToggleAdvanced} size="small" />
        </Grid>
      </Grid>

      <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
        <ListItemButton
          onClick={() => {
            setSettingsMenuOpen(true);
          }}
        >
          <ListItemIcon>
            <Setting2 size={20} />
          </ListItemIcon>
          <ListItemText primary="Settings" />
        </ListItemButton>

        {hasViewOrderPermission && (
          <ListItemButton
            onClick={() => {
              setIsOrderRequestDrawerOpen(true);
            }}
          >
            <ListItemIcon>
              <Bag2 size={20} />
            </ListItemIcon>
            <ListItemText primary="Order Requests" />
            <Badge badgeContent={orderRequestCount} color="error" />
          </ListItemButton>
        )}

        {hasViewOrderPermission && (
          <ListItemButton
            onClick={() => {
              setIsOrderRequestDrawerRecommendationOpen(true);
            }}
          >
            <ListItemIcon>
              <Like1 size={20} variant="Outline" />
            </ListItemIcon>
            <ListItemText primary="Recommendation Requests" />
            <Badge badgeContent={recommendationRequestCount} color="error" />
          </ListItemButton>
        )}

        <ListItemButton
          onClick={() => {
            setOpenDisconnectModal(true);
          }}
        >
          <ListItemIcon>
            <PowerSettingsNewIcon sx={{ fontSize: '20px' }} />
          </ListItemIcon>
          <ListItemText primary="Disconnect Kite" />
        </ListItemButton>

        <ListItemButton
          onClick={() => {
            setOpenChangePasswordModal(true);
          }}
        >
          <ListItemIcon>
            <Lock1 size={20} />
          </ListItemIcon>
          <ListItemText primary="Change Password" />
        </ListItemButton>

        <ListItemButton
          onClick={() => {
            setOpenLogoutModal(true);
          }}
        >
          <ListItemIcon>
            <LogoutIcon sx={{ fontSize: '18px' }} />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </ListItemButton>
      </List>
    </>
  );
};

export default ProfileTab;
